import {
  Box,
  FormHelperText,
  SxProps,
  TextField,
} from '@mui/material';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { useField } from 'formik';
import React, { FC } from 'react';

interface DateTimePickerFieldProps {
  name: string;
  label?: string;
  sx?: SxProps;
}

export const DateTimePickerField: FC<DateTimePickerFieldProps> = ({ label, sx, ...props }) => {
  const [field, meta, helpers] = useField<string>(props);

  return (
    <Box display="flex" flexDirection="column" sx={sx}>
      <DesktopDateTimePicker
        value={field.value}
        onChange={(date) => helpers.setValue(date || '')}
        renderInput={(params) => <TextField {...params} label={label} />}
      />
      {meta.error ? (
        <FormHelperText error>{meta.error}</FormHelperText>
      ) : null}
    </Box>
  );
};

DateTimePickerField.defaultProps = {
  label: '',
  sx: {},
};
